const NotFound = () => (
  <div>
    <h1> Invalid Path </h1>
  </div>
);

export default NotFound;
